module.exports = __webpack_public_path__ + "static/uni_bethune-5c1091fcbad80904cea3875a6e0a54d9.png";